import { AppError } from './app-error'

export class NotFoundError extends AppError {
  private static NAME: string = 'BadRequestError'
  public static MESSAGE: string = 'Conteúdo não localizado'

  constructor(message?: string | null, title?: string | undefined) {
    super(NotFoundError.NAME, message ?? NotFoundError.MESSAGE, title)
  }
}
